module.exports = __webpack_public_path__ + "static/medal-miwc-gold-d567ad9b268da68454d224068bbfe182.png";